// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import clsx from 'clsx'
import styles from './ReadBar.module.css'
import type { OwnerReadAggregate } from 'lib/dealhunt/types'
import { READ_LABEL } from 'lib/owner-notes/card-owners'

/**
 * One read's split as gapped, rounded segments — better · as expected · worse — the way the
 * lab histograms draw their buckets (design option A, 2026-09-23). Violet for "better" and a
 * pale violet for "as expected" keep the owner surfaces in the dial's neutral hue; "worse"
 * stays red because it is the one answer a buyer must not miss. Zero answers draw nothing,
 * so a gap never stands in for an empty segment.
 */
export const ReadBar: React.VFC<{ read: OwnerReadAggregate }> = ({ read }) => (
  <span className={styles.bar} aria-hidden="true">
    {read.better > 0 && (
      <span className={clsx(styles.seg, styles.better)} style={{ flexGrow: read.better }} />
    )}
    {read.expected > 0 && (
      <span className={clsx(styles.seg, styles.expected)} style={{ flexGrow: read.expected }} />
    )}
    {read.worse > 0 && (
      <span className={clsx(styles.seg, styles.worse)} style={{ flexGrow: read.worse }} />
    )}
  </span>
)

/** The three swatches, worded; decorative — the split text on each row carries the figures. */
export const ReadLegend: React.VFC<{ className?: string }> = ({ className }) => (
  <ul className={clsx(styles.legend, className)} aria-hidden="true">
    <li className={styles.legendItem}>
      <span className={clsx(styles.swatch, styles.better)} />
      {READ_LABEL.better}
    </li>
    <li className={styles.legendItem}>
      <span className={clsx(styles.swatch, styles.expected)} />
      {READ_LABEL.expected}
    </li>
    <li className={styles.legendItem}>
      <span className={clsx(styles.swatch, styles.worse)} />
      {READ_LABEL.worse}
    </li>
  </ul>
)
